export default __webpack_public_path__ + "static/media/acorn_street.66ce9f1a.png";